



















































import Vue from 'vue'
import Component from 'vue-class-component'

import PageTitle from '../../../components/PageTitle.vue'
import UserProfile from '../components/UserProfile/UserProfile.vue'
import {
  BonusHistoryTypes,
  FullBonusHistory,
  RefBonusHistory
} from '../includes/types/BonusHistory'
import { BonusInfo } from '../includes/types/BonusInfo'
import { InvoiceInfoWithTargets } from "../includes/types/Shared/InvoiceInfo.types";
import { getBonusHistory, getBonusInfo } from '../services/ProfileBonusService'

@Component({
  components: {
    PageTitle,
    UserProfile,
  },
})
export default class Profile extends Vue {
  bonusInfoType = {
    ref: 'Ref',
    invoice: 'Invoice',
    bonus: 'Bonus',
    full: 'Full',
  }

  bonusInfo: BonusInfo | null = null

  invoices: FullBonusHistory | null = null

  referralsInvoices: RefBonusHistory | null = null

  fullBonusHistory: FullBonusHistory = []

  refBonusHistory: RefBonusHistory = []

  recurringInvoices: Array<InvoiceInfoWithTargets> = []

  limit = 10

  loading = false

  get profile() {
    return this.$store.state.AdminTemplate.applicationConfig?.profile
  }

  get pageTitleHelpMessage(): any {
    if (this.profile) {
      const titleHelpMessage = this.profile?.titleHelpMessage

      if (titleHelpMessage) {
        return titleHelpMessage
      }
    }

    return null
  }

  get advertButtonLink() {
    if (this.profile?.advertiseButton) {
      return this.profile.advertiseButton(this.$i18n.locale)
    }

    return null
  }

  async loadInvoices(): Promise<void> {
    try {
      this.loading = true

      const response = await getBonusHistory<BonusHistoryTypes.Full>(BonusHistoryTypes.Full, this.invoices!.length, this.limit)

      if (response) {
        this.invoices?.push(...response.items)
      }

    } catch (error: any) {
      console.error(error)
    } finally {
      this.loading = false
    }
  }

  async loadReferrals(): Promise<void> {
    try {
      this.loading = true

      const response = await getBonusHistory<BonusHistoryTypes.Ref>(BonusHistoryTypes.Ref, this.referralsInvoices!.length, this.limit)

      if (response) {
        this.referralsInvoices?.push(...response.items)
      }

    } catch (error: any) {
      console.error(error)
    } finally {
      this.loading = false
    }
  }

  get recurringInvoicesApi() {
    return this.profile?.recurringInvoices
  }

  getRecurringInvoices() {
    return this.recurringInvoicesApi?.getRecurringInvoicesReq()
  }

  deleteRecurringInvoice(invoice: InvoiceInfoWithTargets) {
    if (this.recurringInvoicesApi) {
      this.recurringInvoicesApi.deleteRecurringInvoiceReq(invoice, this)
        .then((invoice: unknown) => {
          if (typeof invoice === "number") {
            this.recurringInvoices = this.recurringInvoices.filter(i => i.invoice_number !== invoice)
          }
        })
    }
  }

  isLoading = false

  async mounted(): Promise<void> {
    this.$store.dispatch('AdminTemplate/hideSaveConfigButton')

    try {
      this.isLoading = true

      const response = await Promise.all([
        getBonusInfo(),
        getBonusHistory<BonusHistoryTypes.Full>(BonusHistoryTypes.Full, this.fullBonusHistory.length, this.limit),
        getBonusHistory<BonusHistoryTypes.Ref>(BonusHistoryTypes.Ref, this.refBonusHistory.length, this.limit),
        ...this.recurringInvoicesApi ? [ ...this.getRecurringInvoices() ] : []
      ])

      if (response[0]) {
        this.bonusInfo = response[0]
      }

      if (response[1]) {
        this.invoices = response[1].items
      }

      if (response[2]) {
        this.referralsInvoices = response[2].items
      }

      if (response[3]) {
        this.recurringInvoices = response[3]
      }
    } catch (error: any) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
